// Sunway Square restaurant locations and directory links
export const restaurantLocations = {
  '103 Coffee': 'https://www.sunwaysquare.com/mall/directory/103-coffee',
  "A'Decade": 'https://www.sunwaysquare.com/mall/directory/adecade',
  'Armoury Steakhouse': 'https://www.sunwaysquare.com/mall/directory/armoury-steakhouse',
  'Ba Shu Jia Yan': 'https://www.sunwaysquare.com/mall/directory/ba-shu-jia-yan',
  'Beutea': 'https://www.sunwaysquare.com/mall/directory/beutea',
  'Black Canyon': 'https://www.sunwaysquare.com/mall/directory/black-canyon',
  'Bread History': 'https://www.sunwaysquare.com/mall/directory/bread-history',
  'Chagee': 'https://www.sunwaysquare.com/mall/directory/chagee',
  'ChaPanda': 'https://www.sunwaysquare.com/mall/directory/chapanda',
  'Chatramue': 'https://www.sunwaysquare.com/mall/directory/chatramue',
  "Christine's Bakery Cafe": 'https://www.sunwaysquare.com/mall/directory/christines-bakery-café',
  'CHUCHAT': 'https://www.sunwaysquare.com/mall/directory/chuchat',
  'Coffee Bean': 'https://www.sunwaysquare.com/mall/directory/coffee-bean',
  'Yakiniku Smile': 'https://www.sunwaysquare.com/mall/directory/yakiniku-smile',
  'Count (Flower Drum)': 'https://www.sunwaysquare.com/mall/directory/count-flower-drum',
  'CU Mart': 'https://www.sunwaysquare.com/mall/directory/cu-mart',
  'DOZO': 'https://www.sunwaysquare.com/mall/directory/dozo',
  'Empire Sushi': 'https://www.sunwaysquare.com/mall/directory/empire-sushi',
  'Far Coffee': 'https://www.sunwaysquare.com/mall/directory/far-coffee',
  'Fong Woh Tong': 'https://www.sunwaysquare.com/mall/directory/fong-woh-tong',
  'Gokoku Japanese Bakery': 'https://www.sunwaysquare.com/mall/directory/gokoku-japanese-bakery',
  'Gong Cha': 'https://www.sunwaysquare.com/mall/directory/gong-cha',
  'Gong Luck Cafe': 'https://www.sunwaysquare.com/mall/directory/gong-luck-café',
  'Han Bun Sik': 'https://www.sunwaysquare.com/mall/directory/han-bun-sik',
  'Happy Potato': 'https://www.sunwaysquare.com/mall/directory/happy-potato',
  'Hock Kee Kopitiam': 'https://www.sunwaysquare.com/mall/directory/hock-kee-kopitiam',
  'I LIKE & Yogurt In A Can': 'https://www.sunwaysquare.com/mall/directory/i-like-and-yogurt-in-a-can',
  "I'm Bagel": 'https://www.sunwaysquare.com/mall/directory/im-bagel',
  'JP & CO': 'https://www.sunwaysquare.com/mall/directory/jp-and-co',
  'Kanteen': 'https://www.sunwaysquare.com/mall/directory/kanteen',
  'Kedai Kopi Malaya': 'https://www.sunwaysquare.com/mall/directory/kedai-kopi-malaya',
  'Kenangan Coffee': 'https://www.sunwaysquare.com/mall/directory/kenangan-coffee',
  'Kha Coffee Roaster': 'https://www.sunwaysquare.com/mall/directory/kha-coffee-roaster',
  'LLAO LLAO': 'https://www.sunwaysquare.com/mall/directory/llao-llao',
  'Luckin': 'https://www.sunwaysquare.com/mall/directory/luckin',
  'Manjoe': 'https://www.sunwaysquare.com/mall/directory/manjoe',
  'Missy Sushi': 'https://www.sunwaysquare.com/mall/directory/missy-sushi',
  'Mr. Wu': 'https://www.sunwaysquare.com/mall/directory/mr-wu',
  'Nasi Lemak Shop': 'https://www.sunwaysquare.com/mall/directory/nasi-lemak-shop',
  'Nine Dragon Char Chan Teng (Kowloon Cafe)': 'https://www.sunwaysquare.com/mall/directory/nine-dragon-char-chan-teng-kowloon-café',
  'Nippon Sushi': 'https://www.sunwaysquare.com/mall/directory/nippon-sushi',
  'Odon Beyond': 'https://www.sunwaysquare.com/mall/directory/odon-beyond',
  'One Dish One Taste': 'https://www.sunwaysquare.com/mall/directory/one-dish-one-taste',
  'Pak Curry': 'https://www.sunwaysquare.com/mall/directory/pak-curry',
  'Ramen Mob': 'https://www.sunwaysquare.com/mall/directory/ramen-mob',
  'Richeese Factory': 'https://www.sunwaysquare.com/mall/directory/richeese-factory',
  'Salad Atelier': 'https://www.sunwaysquare.com/mall/directory/salad-atelier',
  'Shabuyaki by Nippon Sushi': 'https://www.sunwaysquare.com/mall/directory/shabuyaki-by-nippon-sushi',
  "Stuff'D": 'https://www.sunwaysquare.com/mall/directory/stuffd',
  'Subway': 'https://www.sunwaysquare.com/mall/directory/subway',
  'Super Matcha': 'https://www.sunwaysquare.com/mall/directory/super-matcha',
  'Sweetie': 'https://www.sunwaysquare.com/mall/directory/sweetie',
  'Tang Gui Fei Tanghulu': 'https://www.sunwaysquare.com/mall/directory/tang-gui-fei-tanghulu',
  'Tealive Plus': 'https://www.sunwaysquare.com/mall/directory/tang-gui-fei-tanghulu',
  'The Chicken Rice Shop': 'https://www.sunwaysquare.com/mall/directory/the-chicken-rice-shop',
  'The Public House': 'https://www.sunwaysquare.com/mall/directory/the-public-house',
  'The Walking Hotpot Signature': 'https://www.sunwaysquare.com/mall/directory/the-walking-hotpot-signature',
  'Yama by Hojichaya': 'https://www.sunwaysquare.com/mall/directory/yama-by-hojichaya',
  'Yellow Bento': 'https://www.sunwaysquare.com/mall/directory/yellow-bento',
  'Yogurt Planet': 'https://www.sunwaysquare.com/mall/directory/yogurt-planet',
  'Yonny': 'https://www.sunwaysquare.com/mall/directory/yonny',
  'Zok Noodle House': 'https://www.sunwaysquare.com/mall/directory/zok-noodle-house',
  'Zus Coffee': 'https://www.sunwaysquare.com/mall/directory/zus-coffee',
};

export const getRestaurantLocation = (restaurantName) => {
  return restaurantLocations[restaurantName] || null;
};
